import React from 'react';
import { Tag, Button, Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isAndroid } from 'react-device-detect';
import { ProductWrapper, CardStyled } from './Product.styled';
import { Text, FlexDivCenter } from '../Typography/Typography';
import { formatCurrency } from '../../utils';

export default ({
  name,
  usePromo,
  dateAndTime,
  description,
  imageUrl,
  type,
  price,
  discountPrice,
  id,
  availableAmount,

}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const buttonTextByProductType = {
    rent: t('to_rent_product'),
    sell: t('to_buy_product'),
    event: t('to_reserve_event'),
    gift: t('read_more'),
  };
  const renderProductType = (val) => {
    const tagColorMapper = {
      gift: 'green',
      rent: 'orange',
      sell: 'red',
      sg_services: 'orange',
      locker: 'blue',
    };
    return (
      <Text size="medium">
        <Tag style={{ fontSize: 18 }} color={tagColorMapper[val]}>
          {' '}
          {`${t(val)}`}
        </Tag>{' '}
        { }
      </Text>
    );
  };

  function onProductClicked() {
    history.push(`/product/${id}`);
  }

  const renderPrice = () => (
    <Text size="medium" style={{ fontSize: 18 }}>

      {price && price !== t("changed") ? (
        <>
          <Tag
            style={{
              margin: 5,
              textAlign: 'center',
              padding: '5px 10px',
              fontSize: 14,
            }}
            color="blue"
          >
            {(discountPrice || discountPrice === 0) ? (
              <>
                {discountPrice ? `${t('discount_price')}: ${formatCurrency(discountPrice)}` : `${t('discount_price')}: ${t('free')}`}
                <br />
              </>
            ) : (
              ''
            )}
            {`${t('price')}: ${formatCurrency(price)}`}
          </Tag>
        </>
      ) : type === 'sg_services' ? (
        <Tag
          style={{ margin: 5, padding: '5px 10px', fontSize: 14 }}
          color="orange"
        >
          {t('free')}
        </Tag>
      ) : (
        ''
      )}
    </Text>
  );

  return availableAmount > 0 ? (
    <ProductWrapper>
      <CardStyled onClick={onProductClicked}>
        {imageUrl && (
          <img
            src={imageUrl}
            style={{
              margin: 5,
              position: 'relative',
              width: !dateAndTime && 180,
              height: !dateAndTime ? 120 : 80,
            }}
            alt="image"
          />
        )}
        {/* {renderProductType[type]} */}
        <FlexDivCenter>
          <Text size="xlarge">{name}</Text>
        </FlexDivCenter>
        {renderPrice(price)}
        {dateAndTime && (
          <FlexDivCenter>
            <Text size="large">{dateAndTime}</Text>
          </FlexDivCenter>
        )}
        <FlexDivCenter>
          {isAndroid ? (
            <button>{buttonTextByProductType[type] || t('get_product')}</button>
          ) : (
            <Button
              style={{
                position: 'absolute',
                color: '#FFF',
                background: '#1D3E7E',
                bottom: 15,
              }}
            >
              {buttonTextByProductType[type]}
            </Button>
          )}
        </FlexDivCenter>
        <div />
      </CardStyled>
    </ProductWrapper>
  ) : null;
};
